import scoringComponent from '@/api/student-scoring-component-entry'
import classOperation from '@/api/class-operation'
import Enrollment from '@/api/student-enrollment'
import grade from '@/api/grade'
import score from '@/api/student-scoring-entry'
import acYear from '@/api/academic-year'
import mainProgram from '@/api/main-program'
import acTerm from '@/api/term-semester'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  scoring_cycle_id: '',
  ac_year_id: null,
  branch_id: [],
  acp_id: null,
  ac_term_id: null,
  scoring_cycles: [],
  subjects: [],
  ac_status_id: 1,
  scoring_cycle_values: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_SCORING_CYCLE_ID(state, id) {
    state.scoring_cycle_id = id
  },
  SET_BRANCH_LIST(state, branch_id) {
    state.branch_id = branch_id
  },
  SET_AC_YEAR_ID(state, ac_year_id) {
    state.ac_year_id = ac_year_id
  },
  SET_MAIN_PROGRAM(state, acp_id) {
    state.acp_id = acp_id
  },
  SET_AC_TERM_ID(state, ac_term_id) {
    state.ac_term_id = ac_term_id
  },
  SET_SCORING_CYCLES(state, data) {
    state.scoring_cycles = data
  },
  SET_AC_STATUS(state, acStatusId) {
    state.ac_status_id = acStatusId
  },
  SET_SUBJECTS(state, data) {
    state.subjects = data
  },
  SET_SCORING_CYCLE_VALUES(state, data) {
    state.scoring_cycle_values = data
  },
  RESET_FILTER(state) {
    ; (state.scoring_cycle_id = 2),
      (state.ac_year_id = null),
      (state.branch_id = []),
      (state.acp_id = null),
      (state.ac_term_id = null)
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        scoring_cycle_id: context.state.scoring_cycle_id,
        branch_id: context.state.branch_id,
        ac_year_id: context.state.ac_year_id,
        acp_id: context.state.acp_id,
        ac_term_id: context.state.ac_term_id
      },
      attributes
    )

    return scoringComponent.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  // Store Scoring
  store(context, data) {
    return scoringComponent.store(data)
  },

  async find(context, params) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await scoringComponent.find(params.student_id, { params: params })
      context.commit('SET_EDIT_DATA', response.data)
    }
  },

  // Get Subject Component Items
  getSubjectComponentItems(context, { subject_id }) {
    return scoringComponent.getSubjectComponentItems(subject_id)
  },

  // Get Subject Component Items
  getSubjectComponentItemDetails(context, data) {
    return scoringComponent.getSubjectComponentItemDetails(data)
  },
  // Get Student Enrollment by Class
  getStudentEnrollmentByClass(context, attributes) {
    return Enrollment.get({
      params: {
        filter: {
          branch_id: attributes.branch_id,
          class_id: attributes.class_id
        },
        page: -1
      }
    })
  },
  // Get Class Operation
  getClassOperation(context) {
    return classOperation.get({
      params: {
        include: 'main_program,academic_year,academic_term,teacher',
        fields: {
          academic_classes: 'class_id,class_name,acp_id,ac_year_id,ac_term_id,grade_id,teacher_resp_id,class_desc,acps_id,branch_id',
          main_program: 'acp_id,acp_name_foreign',
          academic_term: 'ac_term_id,term_name,term_order',
          academic_year: 'ac_year_id,ac_year',
          teacher: 'teacher_id,fname_foreign,lname_foreign'
        },
        filter: {
          ac_status_id: context.state.ac_status_id
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  // Get Subject by Grade
  getGrade(context, { grade_id }) {
    return grade.get({
      params: {
        include: 'grade_subject_has_items',
        fields: {
          academic_program_level_grades: 'grade_id',
        },
        filter: {
          subject: grade_id
          // grade_id: 
        },
        // page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  // Get Academic Year
  getAcYear(context) {
    return acYear.get({
      params: {
        fields: {
          academic_years: 'ac_year_id,ac_year'
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getMainProgram(context) {
    return mainProgram.get({
      params: {
        fields: {
          academic_program_mains: 'acp_id,acp_name_foreign'
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getAcTerm(context) {
    return acTerm.get({
      params: {
        include: 'sub_program',
        fields: {
          academic_terms: 'ac_term_id,term_name,ac_status_id,acps_id'
        },
        filter: {
          ac_year_id: context.state.ac_year_id
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  destroy(context, id) {
    return scoringComponent.destroy(id)
  },
  getGradingComponent(context, { grade_id, sc_bas_id }) {
    return scoringComponent.getGradingComponent(grade_id, sc_bas_id)
  },
  async getScoringCycle(context, params) {
    let response = await score.getScoringCycle({
      params: params
    })
    context.commit('SET_SCORING_CYCLES', response.data)
  },
  async getScoringCycleValue(context) {
    let response = await score.getScoringCycleValue()
    context.commit('SET_SCORING_CYCLE_VALUES', response.data)
  },
  getTermByMainProgram(context, { ac_year_id, acp_id }) {
    return acTerm.get({
      params: {
        fields: {
          academic_terms: 'ac_term_id,term_name,ac_status_id'
        },
        filter: {
          ac_year_id: ac_year_id,
          by_main_program: acp_id,
          ac_status_id: 2
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  }
}
